export default class WEBsellentModal {
    constructor(modalOpenClass) {
        this.modalButtons = document.querySelectorAll(modalOpenClass);
        this.activeModal = null;
        this.event();
        this.closeEvent = new Event('WEBsellentModalClosed');
    }

    event() {
        this.modalButtons.forEach(modal => {

            modal.addEventListener('click', (e) => {

                const modalToOpen = e.currentTarget.dataset.target;
                this.activeModal = document.getElementById(modalToOpen);
                const closeModal = this.activeModal.querySelector('.modal__close');

                this.activeModal.classList.remove('hidden');
                this.activeModal.setAttribute("aria-hidden", "false");
                document.body.classList.add('overflow-hidden');


                window.addEventListener('click', (e) => {
                    e.target === this.activeModal ? this.hideModal() : false;
                })

                window.addEventListener('keydown', (e) => {
                    e.key === 'Escape' ? this.hideModal() : false;
                })

                closeModal.addEventListener('click', () => {
                    this.hideModal();
                });
            })
        });
    }


    hideModal() {
        if (this.activeModal === null) return;
        this.activeModal.classList.add('hidden');
        this.activeModal.setAttribute("aria-hidden", "true");
        document.dispatchEvent(this.closeEvent);
        this.activeModal = null;

        document.body.classList.remove('overflow-hidden');
    }
}